import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef, TemplateRef, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { ILogin } from '../../shared/models/login';
import { IUser, IPermission } from '../../shared/models/user';
import { RegisterService } from '../../shared/providers/register.service'
import { IRegister } from '../../shared/models/register.model';
import { IRegisterOutput } from '../../shared/models/registeroutput.model';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../shared/providers/toast.service';
import { IForgotPassword } from '../../shared/models/forgotpasswordInput';
import { ForgotPasswordService } from '../../shared/providers/forgot-password.service';
import { ResultOutputModel } from '../../shared/models/resultOutputModel';
//import { AuthService } from 'angularx-social-login';
//import { SocialUser } from 'angularx-social-login';
//import { GoogleLoginProvider, FacebookLoginProvider, LinkedInLoginProvider } from 'angularx-social-login';
import { SocialLoginInputModel } from '../../shared/models/SocialLoginInputModel'
import { SocialLoginOutputModel } from '../../shared/models/SocialLoginOutputModel'
import { CommonService } from '../../shared/providers/common.service'
import { IUserRole } from '../../shared/models/UserRoleOutputModel';
import { ValidationService } from '../../shared/providers/validation.service';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { AuthService } from '../../shared/auth/auth.service';
import { LoaderService } from '../../shared/providers/loader.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { IPropertySearchCriteria } from '../../shared/models/propertysearchcriteria';
import { QueryList } from '@angular/core';

@Component({
  selector: 'app-login-form-auth0',
  templateUrl: './login-form-auth0.component.html'
})
export class LoginFormAuth0Component implements OnInit {

  loginModel = {} as ILogin;
  authResponse = {} as IUser;
  loginFailedMessage = '';
  classToBind: string = 'redtext';
  @Output() onLogin = new EventEmitter();
  checkEmailFailedMessage = '';
  otpVerficationCode = '';
  checkEmailResponse = {} as ResultOutputModel;
  forgotPasswordModel = {} as IForgotPassword;
  OTPVerificationModel = {} as IForgotPassword;
  socialLoginInputModel = {} as SocialLoginInputModel;
  socialLoginOutputModel = {} as SocialLoginOutputModel;

  isLoginActive = false;

  registerModel = {} as IRegister;
  registerResponse = {} as IRegisterOutput;
  registerFailedMessage = '';

  RoleValid: boolean = true;
  firstNameValid: boolean = true;
  lastNameValid: boolean = true;
  emailValid: boolean = true;
  passwordValid: boolean = true;
  confirmpasswordValid: boolean = true;
  phoneValid: boolean = true;
  emailvalidation: string = "";
  passwordValidation: string = "";
  showValidation: boolean = true;
  loopCount: number = 1;
  dis = true;
  private formSumitAttempt: boolean;
  @Input() modalRef: BsModalRef;
  @Input() updatePassword: boolean;
  @Input() updatePasswordUserGuid: string;
  @Input() currentStage: number;
  @Input() userGuid: string = '';
  stage = 1;
  //user: SocialUser;
  userRoleList: IUserRole[];
  redirectUrl = '';
  modalRefNew: BsModalRef;
  phoneValidation: string = "";
  permissions: IPermission[];
  user: any;
  otpCodeLimit = 120;
  IsShowOTPMessage = false;
  otpArray = Array(6); // for 6 inputs
  otpValues: string[] = new Array(6).fill('');
  email = '';
  @ViewChildren('otpBox') otpBoxes!: QueryList<ElementRef>;
  constructor(private router: Router, private authService: AuthenticationService, private _propertyListingService: PropertyListingService, private activatedRoute: ActivatedRoute, private registerService: RegisterService, private _toastService: ToastService,
    private forgotPasswordService: ForgotPasswordService,
    //private socialAuthService: AuthService,
    public _commonService: CommonService,
    private modalService: BsModalService, public Validation: ValidationService, private userManagerService: UserManagerService, public _auth0: AuthService, private _loaderService: LoaderService) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.registerModel.UtmId = params['utm_id'];
      this.registerModel.UtmSource = params['utm_source'];
      this.registerModel.UtmMedium = params['utm_medium'];
      this.registerModel.UtmCampaign = params['utm_campaign'];
      this.registerModel.UtmTerm = params['utm_term'];
      this.registerModel.UtmContent = params['utm_content'];
    });

    this.registerModel.email = this._auth0.loginModel.UserName;
    if (this.registerModel.email != null && this.registerModel.email != '') {
      this.email = this.registerModel.email
    }
    else {
      let user = this.authService.user;
      this.email = user != null && user != undefined ? user["UserName"] : this.registerModel.email;

    }
  
    this.registerModel.Subscribe = true;
    this._commonService.GetUserRolesWithFilter().subscribe(response => {
      this.userRoleList = response.map(o => { return { id: o.Id, name: o.Description }; });
    });
    this.forgotPasswordModel.Email = '';
    this.forgotPasswordModel.ConfirmationCode = null;
    this.forgotPasswordModel.ResetPassword = '';
    this.forgotPasswordModel.ConfirmPassword = '';
    this.classToBind = 'redtext';
    this.showValidation = true;
    this.registerModel.termsAndConditions = false;
    this.registerModel.is1031Exchange = false;
    this.registerModel.userrole = 0;
    if (this.currentStage != null && this.currentStage != undefined && this.currentStage == 5) {
      this.stage = this.currentStage;
    }
    if (this.stage == 5) {
      this.shareFirstAuthenticationCode();
    }
    if (this.updatePassword) {
      this.stage = 4;
    }

    this.authService.redirectUser.subscribe(res => {
      this.redirectUrl = res;
    });

    //this.user = null;
    //this.socialAuthService.signOut();
    //this.socialAuthService.authState.subscribe((user) => {          
    //    this.user = user;
    //    this.socialLogin();
    //});

    //this.registerModel.userrole = 2; //setting principal as default
    this._loaderService.display(false);
  }

  signOut(): void {
    //this.user = null;
    //this.socialAuthService.signOut();
  }

  signInWithGoogle(): void {
    //this.loopCount = 1;
    //this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);

  }

  signInWithFB(): void {
    this.loopCount = 1;
    // this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }

  //signInWithLinkedIn(): void {
  //    this.loopCount = 1;
  //    this.socialAuthService.signIn(LinkedInLoginProvider.PROVIDER_ID);       
  //}    

  //socialLogin() {
  //    
  //    if (this.user != null && this.user != undefined && this.loopCount == 1) {
  //        this.loopCount++;
  //        this.socialLoginInputModel.Email = this.user.email;
  //        this.socialLoginInputModel.Provider = this.user.provider;
  //        this.authService.checkSocialLoginUser(this.socialLoginInputModel).subscribe(response => {
  //            this.socialLoginOutputModel = response;
  //            if (this.socialLoginOutputModel.IsSuccess) {
  //                if (this.socialLoginOutputModel.LoginModel.Success == false) {
  //                    if (this.socialLoginOutputModel.Provider != null) {
  //                        this._toastService.addToast({ title: 'Waring', msg: 'You are already logged in with ' + this.socialLoginOutputModel.Provider, timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
  //                    }
  //                    else {
  //                        this._toastService.addToast({ title: 'Waring', msg: 'You are already logged in with B+E Account', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
  //                    }
  //                }
  //                else {
  //                    this.modalRef.hide();
  //                    this.onLoginOrRegisterClick(true);
  //                    this._toastService.addToast({ title: 'Success', msg: 'You are successfully logged in', timeout: 2000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
  //                    if (this.socialLoginOutputModel.LoginModel.RedirectUrl != "") // For 1031 access
  //                        this.router.navigateByUrl(this.socialLoginOutputModel.LoginModel.RedirectUrl);
  //                    window.scrollTo(0, 0);
  //                }
  //            }
  //            else {
  //                
  //                if (this.user != null && this.user != undefined) {
  //                    if (this.user.name != null && this.user.name != undefined) {
  //                        var name = this.user.name.split(" ");
  //                        this.registerModel.firstName = name[0];
  //                        if (name[1] != null && name[1] != undefined) {
  //                            this.registerModel.lastName = name[1];
  //                        }
  //                    }
  //                    if (this.user.photoUrl != undefined && this.user.photoUrl != null) {
  //                        this.registerModel.profilePicturePath = this.user.photoUrl;
  //                    }
  //                    this.registerModel.email = this.user.email;
  //                    this.registerModel.provider = this.user.provider;
  //                    this.isLoginActive = false;
  //                }
  //            }
  //        });
  //    }

  //}

  onKeydown(event) {
    if (event.key === "Enter") {
      this.onLoginClick();
    }
  }

  onForgotPasswordClick() {
    this.stage = 2;
  }

  changeModal(stage) {
    this.stage = stage;
  }

  onLoginClick() {

    if ((!this.loginModel.hasOwnProperty("UserName") && !this.loginModel.hasOwnProperty("Password")) ||
      this.loginModel.UserName == '' && this.loginModel.Password == '') {
      this.loginFailedMessage = "Username and password cannot be empty";
    }
    else if (!this.loginModel.hasOwnProperty("UserName") || this.loginModel.UserName == '') {
      this.loginFailedMessage = "Username cannot be empty";
    }
    //else if (!this.loginModel.hasOwnProperty("Password") || this.loginModel.Password == '') {
    //    this.loginFailedMessage = "Password cannot be empty";
    //}
    else {
      this.authService.login(this.loginModel).subscribe(response => {
        this.authResponse = response;
        if (this.authResponse.IsAuthenticated && this.authResponse.IsAccountVerified) {
          this.modalRef.hide();

          this.userManagerService.GetUserPermissions(this.authResponse.Id).subscribe(res => {
            this.permissions = res;

            localStorage.setItem("MenuPermissions", JSON.stringify(this.permissions));

            if (this.authResponse.RoleId == this.authService.UserRole.Admin || this.authResponse.RoleId == this.authService.UserRole.SuperAdmin || this.authResponse.RoleId == this.authService.UserRole.DataEntryStaff) {
              this.onLogin.emit(true);
            }
            this.onLoginOrRegisterClick(true);
            this._toastService.addToast({ title: 'Success', msg: 'You are successfully logged in', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success'});
            if (this.authResponse.RedirectUrl != "") // For 1031 access
            {
              this.router.navigateByUrl(this.authResponse.RedirectUrl);
            }
            else if (this.redirectUrl != '') {
              if ((this.authResponse.RoleId == this.authService.UserRole.Principal) || (this.authResponse.RoleId == this.authService.UserRole.Principal1031)) {
                let URL = this.redirectUrl.split('/')[1];
                if (URL != "") {
                  this._commonService.IsOfferPlaced(URL, this.authResponse.Id).subscribe(res => {
                    if (res == false) {
                      this.router.navigateByUrl(this.redirectUrl);
                    }
                    this.clearRedeirectUrl();
                  });
                }
              }

            }
            window.scrollTo(0, 0);
          });
        }
        else {
          this.loginFailedMessage = this.authResponse.FailureMessage;
        }
      });
    }
  }
  showFNSpecCharVal = false;
  showLNSpecCharVal = false;
  specCharValMsg = '!@#$%^&*()_+\-=\[\]{};"\\|<>\/? not allowed';
  onRegisterClick() {
    this.emailvalidation = "";
    this.classToBind = 'redtext';
    let valid: boolean = true;

    if (this.IsinValid(this.registerModel.userrole) || this.registerModel.userrole == 0) {
      this.RoleValid = false;
      valid = false;
    }
    else {
      this.RoleValid = true;
    }

    if (this.IsinValid(this.registerModel.firstName)) {
      this.firstNameValid = false;
      this.showFNSpecCharVal = false;
      valid = false;
    }
    else {
      if (this.Validation.isSpecialCharacterExist(this.registerModel.firstName)) {
        this.firstNameValid = false;
        valid = false;
        //this._toastService.addToast({ title: 'Warning', msg: 'First Name should not contain special characters', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.showFNSpecCharVal = true;
      }
      else {
        this.showFNSpecCharVal = false;
        this.firstNameValid = true;
      }
    }
    if (this.IsinValid(this.registerModel.lastName)) {
      this.lastNameValid = false;
      this.showLNSpecCharVal = false;
      valid = false;
    }
    else {
      if (this.Validation.isSpecialCharacterExist(this.registerModel.lastName)) {
        this.lastNameValid = false;
        valid = false;
        //this._toastService.addToast({ title: 'Warning', msg: 'Last Name should not contain special characters', timeout: 3000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        this.showLNSpecCharVal = true;
      }
      else {
        this.showLNSpecCharVal = false;
        this.lastNameValid = true;
      }
    }

    if (this.registerModel.userrole == 0) {
      this.RoleValid = false;
      valid = false;
    }
    else {
      this.RoleValid = true;
    }

    if (this.IsinValid(this.registerModel.email)) {
      this.emailValid = false;
      valid = false;
    }
    else if (this.isEmail(this.registerModel.email) == false) {
      this.emailValid = false;
      this.emailvalidation = "";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    //if (this.IsinValid(this.registerModel.password)) {
    //    this.passwordValid = false;
    //    valid = false;
    //}
    //else if (this.isPassword(this.registerModel.password) == false) {
    //    this.passwordValid = false;
    //    this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    //}
    //else {
    //    this.passwordValid = true;
    //}
    //if (this.IsinValid(this.registerModel.confirmpassword)) {
    //    this.confirmpasswordValid = false;
    //    valid = false;
    //}
    //else {
    //    this.confirmpasswordValid = true;
    //}
    if (this.IsinValid(this.registerModel.phoneNumber)) {
      this.phoneValid = false;
      valid = false;
    }
    else {
      this.phoneValid = true;
    }

    if (valid) {
      //if (this.isPassword(this.registerModel.password) == false) {
      //    this.passwordValid = false;
      //    this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
      //    valid = false;
      //}
      //else {
      //    this.passwordValidation = "";
      //    this.passwordValid = true;
      //}

      //if (this.isEmail(this.registerModel.email) == false) {
      //    this.emailValid = false;
      //    this.emailvalidation = "Invalid email address";
      //    valid = false;
      //}
      //else if (this.registerModel.password.toString().trim() != this.registerModel.confirmpassword.toString().trim()) {
      //    this.registerFailedMessage = "Password and confirm password are not matching";
      //    valid = false;
      //}
      if (this.isPhoneNumber(this.registerModel.phoneNumber) == false) {
        this.registerFailedMessage = "Invalid phone number";
        valid = false;
      }
      else if (this.registerModel.termsAndConditions == false) {
        this.registerFailedMessage = "Please agree terms and conditions";
        valid = false;
      }
    }

    if (valid) {

      document.getElementById('Register').classList.add('disabled');
      if (this.registerModel.user1031ExchangeStarts_Date != null) {
        //Converting Local Date into UTC Date
        let UTCDate = (this.registerModel.user1031ExchangeStarts_Date.toUTCString());
        this.registerModel.user1031ExchangeStarts = UTCDate;
      }
      else {
        this.registerModel.user1031ExchangeStarts = null;
      }

      if (this.registerModel.IsBroker) {

        this.registerModel.userrole = this.authService.UserRole.ExternalBroker;
      }
      this._loaderService.display(true);
      this.email = this.registerModel.email;
      this.registerService.registerUser(this.registerModel).subscribe(response => {
        this.registerResponse = response;
        this.userGuid = this.registerResponse.Guid;
        this._loaderService.display(false);
        if (this.registerResponse.Success) {
          this.showValidation = false;
          this.onLoginOrRegisterClick(true);
          this.changeModal(5);
          this.clearRegisterFeilds();
          this.classToBind = 'greentext';
          this.authService.IsCalledTheOtp = true;
          this.shareFirstAuthenticationCode();
          //  window.scrollTo(0, 0);
          //this.modalRef.hide();

        }
        else {
          this.classToBind = 'redtext';
          this.registerFailedMessage = this.registerResponse.FailureMessage;
          document.getElementById('Register').classList.remove('disabled');
        }

      });;
    }

  }

  redirectToPlatformUrl() {
    if (this.redirectUrl != '') {
      if (this.registerResponse.Role.toUpperCase().indexOf("PRINCIPAL") > -1) {
        this.router.navigateByUrl(this.redirectUrl);
      }

      this.clearRedeirectUrl();
    }
    else {
      if (sessionStorage.getItem('currentRedirectUrl') != null && sessionStorage.getItem('currentRedirectUrl') != '') {
        let currentUrl = sessionStorage.getItem('currentRedirectUrl');
        if (currentUrl.indexOf('my-profile') > -1) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigate(['/my-profile']));
        }
        else {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
            this.router.navigateByUrl(currentUrl));
        }
        sessionStorage.removeItem('currentRedirectUrl');
      }
      else if (this.authService.Principal() || this.authService.Principal1031()) {
        let currentRedirectUrl = "/principal-dashboard";
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigateByUrl(currentRedirectUrl));
      }
      else {
        let href = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
          this.router.navigateByUrl(decodeURIComponent(href)));
        if (localStorage.getItem('IsFromCopyLink') != null && localStorage.getItem('IsFromCopyLink') != '') {
          const logs = {
            UserId: this.registerResponse != null && this.registerResponse.Id != null ? this.registerResponse.Id : 0,
            SourcePage: 'LoginFormAuth0-onRegisterClick-else',
            RedirectionUrl: decodeURIComponent(href)
          }
          this._commonService.AddLogs(logs).subscribe(response => {
          });
        }
      }

    }
  }

  clearRedeirectUrl() {
    this.authService.redirectUserTo('');
  }

  clearRegisterFeilds() {
    this.registerModel.firstName = null;
    this.registerModel.lastName = null;
    this.registerModel.email = null;
    this.registerModel.phoneNumber = '';
    this.registerModel.password = null;
    this.registerModel.is1031Exchange = false;
    this.registerModel.termsAndConditions = false;
    this.registerModel.user1031ExchangeStarts = null;
    this.registerModel.user1031ExchangeStarts_Date = null;
    this.registerModel.confirmpassword = null;
    this.classToBind = 'redtext';
    this.registerFailedMessage = null;
    this.registerModel.userrole = 0;

    this.RoleValid = true;
    this.firstNameValid = true;
    this.lastNameValid = true;
    this.emailValid = true;
    this.passwordValid = true;
    this.confirmpasswordValid = true;
    this.phoneValid = true;
    this.emailvalidation = "";
    this.showFNSpecCharVal = false;
    this.showLNSpecCharVal = false;
  }

  clearExchangeStart(eve: any) {

    if (this.registerModel.is1031Exchange == false) {
      this.registerModel.user1031ExchangeStarts = "";
      this.registerModel.user1031ExchangeStarts = "";
      this.registerModel.is1031Exchange = false;
    }
  }

  isEmail(search: string): boolean {
    var serchfind: boolean;
    var regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    serchfind = regexp.test(search);
    return serchfind;
  }

  isPassword(search: string): boolean {
    var searchfind: boolean;
    var regexp = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})");
    searchfind = regexp.test(search);
    return searchfind;

  }
  isPhoneNumber(search: any) {
    var serchfind: boolean;
    var regexp = new RegExp(/^\d{10}$/);
    serchfind = regexp.test(search);
    return serchfind;
  }

  validateemail() {

    if ((this.isEmail(this.registerModel.email) == false) && !this.IsinValid(this.registerModel.email)) {
      this.emailValid = false;
      this.emailvalidation = "invalid Email address";
    }
    else {
      this.emailValid = true;
      this.emailvalidation = "";
    }
    if (this.IsinValid(this.registerModel.email)) {
      this.emailValid = false;
    }
  }
  forgotPasswordValidation = '';
  forgotPasswordValid = true;
  validateForgotPassword() {
    if ((this.isPassword(this.forgotPasswordModel.ResetPassword) == false) && !this.IsinValid(this.forgotPasswordModel.ResetPassword)) {
      this.forgotPasswordValid = false;
      this.forgotPasswordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    }
    else {
      this.forgotPasswordValid = true;
      this.forgotPasswordValidation = "";
    }
    if (this.IsinValid(this.forgotPasswordModel.ResetPassword)) {
      this.forgotPasswordValid = false;
    }
    else {
      this.forgotPasswordValid = true;
    }
  }

  validatepassword() {
    if ((this.isPassword(this.registerModel.password) == false) && !this.IsinValid(this.registerModel.password)) {
      this.passwordValid = false;
      this.passwordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    }
    else {
      this.passwordValid = true;
      this.passwordValidation = "";
    }
    if (this.IsinValid(this.registerModel.password)) {
      this.passwordValid = false;
    }
    else {
      this.passwordValid = true;
    }
  }

  IsinValid(value: any) {

    if (value == undefined || value == '' || value == null) {
      return true;
    }
    if (value.toString().trim().length <= 0) {
      return true;
    }
    if (!value) {
      return true;
    }
    return false;
  }

  onLoginOrRegisterClick(tab: boolean) {
    this.isLoginActive = tab;
    if (tab) {
      this.showValidation = false;
      this.clearRegisterFeilds();
    }
    else
      this.clearLoginFields();
  }

  onCheckEmailClick() {
    $('#aForgotPasswordId').hide();
    this.checkEmailFailedMessage = '';
    if (this.forgotPasswordModel.Email == '' || this.forgotPasswordModel.Email == undefined) {
      this.checkEmailFailedMessage = "Email cannot be empty"
    }
    else {
      this.forgotPasswordService.checkEmail(this.forgotPasswordModel).subscribe(response => {
        this.checkEmailResponse = response;
        if (this.checkEmailResponse.Success) {
          this.stage = 3;
          this.forgotPasswordModel.Email = '';
        }
        else {
          this.checkEmailFailedMessage = this.checkEmailResponse.ReturnMsg;
        }
      });
    }
  }

  onConfirmationCodeClick() {
    this.checkEmailFailedMessage = '';
    if (this.forgotPasswordModel.ConfirmationCode == null || this.forgotPasswordModel.ConfirmationCode == undefined) {
      this.checkEmailFailedMessage = "Confirmation code cannot be empty"
    }
    else {
      this.forgotPasswordModel.Guid = this.checkEmailResponse.Guid;
      this.forgotPasswordService.checkConfirmationcode(this.forgotPasswordModel).subscribe(response => {
        if (response.Success) {
          this.checkEmailResponse = response;
          this.stage = 4;
          this.forgotPasswordModel.ConfirmationCode = null;
        }
        else {
          this.checkEmailFailedMessage = 'Please enter valid confirmation code';
        }
      });
    }
  }

  onResetPasswordClick() {
    //this.modalRefNew.hide();
    this.checkEmailFailedMessage = '';
    if (this.IsPasswordValid()) {
      if (this.updatePassword) {
        this.forgotPasswordModel.Guid = this.updatePasswordUserGuid;
      }
      else {
        this.forgotPasswordModel.Guid = this.checkEmailResponse.Guid;
      }

      this.forgotPasswordService.resetPassword(this.forgotPasswordModel).subscribe(response => {
        if (response) {
          this._toastService.addToast({ title: 'Success', msg: 'Your password has been changed successfully!', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
          this.modalRef.hide();
        }
        else {
          this.checkEmailFailedMessage = 'Update failed.Try again';
        }
      });
    }
  }

  IsPasswordValid() {
    let valid = true;
    if (this.forgotPasswordModel.ResetPassword == '' || this.forgotPasswordModel.ResetPassword == undefined) {
      this.checkEmailFailedMessage = "New Password cannot be empty";
      valid = false;
    }
    else if (this.forgotPasswordModel.ConfirmPassword == '' || this.forgotPasswordModel.ConfirmPassword == undefined) {
      this.checkEmailFailedMessage = "Confirm Password cannot be empty";
      valid = false;
    }
    else if (this.forgotPasswordModel.ConfirmPassword != this.forgotPasswordModel.ResetPassword) {
      this.checkEmailFailedMessage = "The New Password and Confirm Password you entered do not match.";
      valid = false;
    }
    else if (this.isPassword(this.forgotPasswordModel.ResetPassword) == false) {
      this.forgotPasswordValid = false;
      valid = false;
      this.forgotPasswordValidation = "Must contain at least one number, one uppercase letter, one lowercase letter and at least 8 characters";
    }
    return valid;
  }
  validatePhoneNumber() {
    if (this.isPhoneNumber(this.registerModel.phoneNumber) == false) {
      this.phoneValidation = "Invalid phone number";
    }
    else {
      this.phoneValidation = "";
    }
  }

  clearLoginFields() {
    this.loginModel.UserName = '';
    this.loginModel.Password = '';
    this.loginFailedMessage = '';
  }
  RoleChange() {
    this.registerModel.is1031Exchange = false;
    if (this.registerModel.userrole !== 0) {
      this.RoleValid = true;
    }
  }

  openModal(template: TemplateRef<any>, classes: any) {
    if (this.IsPasswordValid()) {
      this.modalRefNew = this.modalService.show(template, { class: classes });
    }
  }
  emailFailMessageHide() {
    this.checkEmailFailedMessage = "";
  }
  onCheckboxSelect(type: number) {

    if (type == 1) {
      this.registerModel.IsBroker = false;
    }
    else {
      this.registerModel.is1031Exchange = false;
    }
  }
  isDisabled = false;

  onOTPVerficationClick() {
    this.isDisabled = true;
    const otp = this.otpValues.join('');
    if (otp != null && otp != undefined) {
      if (otp.length == 6) {
        if (this.otpCodeLimit > 0) {
          this.OTPVerificationModel.Email = this.registerModel.email;
          this.OTPVerificationModel.ConfirmationCode = Number(otp);
          this.OTPVerificationModel.ResetPassword = '';
          this.OTPVerificationModel.ConfirmPassword = '';
          this.userManagerService.saveOTPVerification(this.OTPVerificationModel).subscribe(response => {
            if (response == "Success") {
              this.isDisabled = false;
              this.modalRef.hide();
              this.authService.verifiedIn.next(true);
              this.authResponse.IsAccountVerified = true;
              this.authResponse.IsAuthenticated = true;
              this._auth0.isRegistration = false;
              this._toastService.addToast({ title: 'Success', msg: 'You are successfully logged in.', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
              this.otpValues = [];
              this.redirectToPlatformUrl();
            }
            else if (response == "Not Match") {
              this.isDisabled = false;
              this.otpValues = [];
              this.onFocusToFirstItem();
              this._toastService.addToast({ title: 'Error', msg: 'OTP is not matching, Please enter the valid one', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });

            }
            else {
              this.isDisabled = false;
              this.otpValues = [];
              this.onFocusToFirstItem();
              this._toastService.addToast({ title: 'Error', msg: 'Something went wrong', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
            }
          });
        }
        else {
          this.isDisabled = false;
          this.otpValues = [];
          this.onFocusToFirstItem();
          this._toastService.addToast({ title: 'Error', msg: 'Your limit is exceeded. Please resend a new code', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
      }
      else {
        this.isDisabled = false;
        this.otpValues = [];
        this.onFocusToFirstItem();
        this._toastService.addToast({ title: 'Error', msg: 'Invalid OTP!', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    }
    else {
      this.isDisabled = false;
      this.otpValues = [];
      this.onFocusToFirstItem();
      this._toastService.addToast({ title: 'Error', msg: 'Please Enter a Valid OTP', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
    }
  }
  updateSlots(input) {
    const value = input.value.split("");
    const slots = document.querySelectorAll("#otpSlots span");

    slots.forEach((slot, i) => {
      slot.textContent = value[i] ? value[i] : "-";
    });
  }

  handlePaste(event: ClipboardEvent, index: number) {
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text') || '';
    const chars = pasteData.trim().split('');

    chars.forEach((char, i) => {
      if (index + i < this.otpArray.length) {
        this.otpValues[index + i] = char;
      }
    });

    // update view and focus next
    const otpBoxesArr = this.otpBoxes.toArray();
    const nextIndex = Math.min(index + chars.length, this.otpArray.length - 1);
    otpBoxesArr[nextIndex].nativeElement.focus();
  }

  moveToNext(event: any, index: number) {
    const input = event.target.value;
    if (input && index < this.otpArray.length - 1) {
      this.otpBoxes.toArray()[index + 1].nativeElement.focus();
    }
  }

  handleKeydown(event: KeyboardEvent, index: number) {
    if (event.key === 'Enter') {
      this.onOTPVerficationClick();
    } else {
      this.moveToPrev(event, index);
    }
  }

  moveToPrev(event: KeyboardEvent, index: number) {
    if (event.key === 'Backspace' && !this.otpValues[index] && index > 0) {
      this.otpBoxes.toArray()[index - 1].nativeElement.focus();
    }
  }

  getOtp(): string {
    return this.otpValues.join('');
  }

  onKeyDownOtp(event: KeyboardEvent, index: number) {
    const input = event.target as HTMLInputElement;
    if (event.key === 'Enter') {
      this.onOTPVerficationClick();
    }
    // handle backspace: move focus back if empty
   else if (event.key === 'Backspace' && !input.value && input.previousElementSibling) {
      (input.previousElementSibling as HTMLInputElement).focus();
    }
  }
  timer: any;
  fiveMinutesTimer: any;
  startTimer() {
    this.otpCodeLimit = 120;
    this.timer = setInterval(() => {
      this.otpCodeLimit--;
      if (this.otpCodeLimit === 0) {
        clearInterval(this.timer);
      }
    }, 1000);
  }

  resendOtp() {
    this.IsShowOTPMessage = true;
    this.startTimer(); // restart timer
  }

  randomOTP(length) {
    var randomChars = '0123456789';
    var result = '';
    for (var i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    this.otpVerficationCode = result;
  }

  async shareFirstAuthenticationCode() {
     this.OTPVerificationModel.ResetPassword = '';
    this.OTPVerificationModel.ConfirmPassword = '';
    this.OTPVerificationModel.Guid = this.userGuid != null ? this.userGuid : null;
    this._loaderService.display(true);
    await this.userManagerService.checkOTPEnabled(this.OTPVerificationModel).subscribe(response => {
      this._loaderService.display(false);
      if (response != null && response.Message == 'Success') {
        this._toastService.addToast({ title: 'Success', msg: 'Email Verification Code sent successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.otpValues = [];
        this.onFocusToFirstItem();
        this.resendOtp();
        this._loaderService.display(false);
      }
      else if (response.Message == "Too many attempts, try again after 7 minutes") {
        this.otpValues = [];
        this.onFocusToFirstItem();
        const now = new Date()
        const futureTime = this.Validation.convertUTCDateToLocalDate1(new Date(response.OtpValidityDate)); // current date & time
        const fiveMinutesLater = new Date(futureTime.getTime() + 7 * 60 * 1000);
        this._loaderService.display(false);
        if (fiveMinutesLater > now) {
          const diffMs = fiveMinutesLater.getTime() - now.getTime(); // difference in milliseconds
          const diffMinutes = Math.floor(diffMs / 60000);
          this.startFiveMinutesTimer(diffMinutes);
          this._toastService.addToast({ title: 'Error', msg: 'Too many attempts, try again after some minutes', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
        }
        else {
          this.otpValues = [];
          this._toastService.addToast({ title: 'Error', msg: 'Too many attempts, try again after some minutes', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
          this.otpCodeLimit = 0;
        }
      }
      else if (response.Message == "Not Match") {
        this._loaderService.display(false);
        this.otpValues = [];
        this.onFocusToFirstItem();
        this._toastService.addToast({ title: 'Error', msg: 'Not Match', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
      else {
        this.otpValues = [];
        this.onFocusToFirstItem();

        this._loaderService.display(false);
        this._toastService.addToast({ title: 'Error', msg: 'Something went wrong', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' });
      }
    });

  }

  startFiveMinutesTimer(minutes) {
    let fiveMinutesTimer = minutes;
    this.fiveMinutesTimer = setInterval(() => {
      fiveMinutesTimer--;
      if (fiveMinutesTimer === 0) {
        clearInterval(this.fiveMinutesTimer);
        this.otpCodeLimit = 0;
      }
    }, 1000);
  }

  hideModel() {
    if (this.stage == 5) {
      this.onLogout();
    }
    else {
      this.modalRef.hide();
    }
  }

  onLogout() {
    // this.socialAuthService.signOut();
    // this._propertyListingService = {} as PropertyListingService;
    this._propertyListingService.criteria = {} as IPropertySearchCriteria;
    this._propertyListingService.criteria.PropertyFor = 601;
    this.authService.logoutClicked = true;

    $("body").removeClass("open-sidemenu");
    window.scrollTo(0, 0);
    if (this.authService.isAuth0Enabled) {
      this._auth0.IsLogOut = true;
      this._auth0.logout();
    }
    else {
      this.authService.logout();
      this.router.navigate(['/']);
    }
    //this.Validation.redirect('/');
  }

  onFocusToFirstItem() {
    const otpBoxesArr = this.otpBoxes.toArray();
    otpBoxesArr[0].nativeElement.focus();
  }
}
